/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_By_TimeInputs */



/**
* | output |
* | --- |
* | "By Time" |
*
* @param {Segment_Event_Group_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_by_time = /** @type {((inputs?: Segment_Event_Group_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Par temps")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach Zeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per tempo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("По времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時間別")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय तक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por tempo")
	return /** @type {LocalizedString} */ ("By Time")
});